import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/axiosInstance';
import { toast } from 'sonner';

const t = (name, fn) =>
  createAsyncThunk(name, async (arg, { rejectWithValue }) => {
    try { return await fn(arg); }
    catch (err) {
      toast.error(err.response?.data?.message || err.message || 'Request failed');
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  });

export const fetchPromotions = t('promotion/fetchAll', async () => {
  const { data } = await api.get('Promotions');
  return data.data;
});

export const createPromotion = t('promotion/create', async (dto) => {
  const { data } = await api.post('Promotions', dto);
  toast.success('Promotion created');
  return data.data;
});

export const updatePromotion = t('promotion/update', async ({ id, dto }) => {
  const { data } = await api.put(`Promotions/${id}`, dto);
  toast.success('Promotion updated');
  return data.data;
});

export const deletePromotion = t('promotion/delete', async (id) => {
  await api.delete(`Promotions/${id}`);
  toast.success('Promotion deleted');
  return id;
});

export const setPromotionActive = t('promotion/setActive', async ({ id, active }) => {
  const { data } = await api.patch(`Promotions/${id}/status?active=${active}`);
  toast.success(active ? 'Promotion activated — others deactivated' : 'Promotion deactivated');
  return data.data;
});

const promotionSlice = createSlice({
  name: 'promotion',
  initialState: { items: [], loading: false, actionLoading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPromotions.pending,   (s) => { s.loading = true; })
      .addCase(fetchPromotions.fulfilled, (s, a) => { s.loading = false; s.items = a.payload || []; })
      .addCase(fetchPromotions.rejected,  (s) => { s.loading = false; })
      .addCase(createPromotion.fulfilled, (s, a) => { s.items = [a.payload, ...s.items]; })
      .addCase(updatePromotion.fulfilled, (s, a) => {
        s.items = s.items.map(i => i.promotionId === a.payload.promotionId ? a.payload : i);
      })
      .addCase(deletePromotion.fulfilled, (s, a) => {
        s.items = s.items.filter(i => i.promotionId !== a.payload);
      })
      .addCase(setPromotionActive.fulfilled, (s, a) => {
        // When one becomes active, deactivate all others in local state too
        s.items = s.items.map(i => ({
          ...i,
          isActive: i.promotionId === a.payload.promotionId ? a.payload.isActive : false
        }));
      });
  }
});

export default promotionSlice.reducer;